var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogomark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 45,
    viewBox: "0 0 91 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5029 0C28.8726 0 15.3911 13.4159 15.3911 29.9652H75.6148C75.6148 13.4159 62.1333 0 45.5029 0Z",
    fill: "#FFA425"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7.86341 22.4739C4.68162 22.4739 1.96088 24.4382 0.859025 27.2148C0.285333 28.6604 1.59626 29.9652 3.15156 29.9652H15.3914C15.3914 25.8278 12.021 22.4739 7.86341 22.4739Z",
    fill: "#FFA425"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6152 29.9653C75.6152 22.9673 80.4364 17.0899 86.9538 15.4428C88.9643 14.9347 90.6712 16.6638 90.6712 18.7375L90.6712 26.2105C90.6712 28.2842 88.9901 29.9653 86.9163 29.9653L75.6152 29.9653Z",
    fill: "#FFA425"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M75.6152 29.9651C75.6152 36.9631 70.794 42.8405 64.2767 44.4876C62.2662 44.9957 60.5593 43.2667 60.5593 41.1929L60.5593 29.9651L75.6152 29.9651Z",
    fill: "#FFA425"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M30.4475 29.9651C30.4475 36.9631 25.6263 42.8405 19.109 44.4876C17.0985 44.9957 15.3916 43.2667 15.3916 41.1929L15.3916 29.9651L30.4475 29.9651Z",
    fill: "#FFA425"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogomark);
export default __webpack_public_path__ + "static/media/logomark.1ac0800cbcd389cce49d017d3b5878c4.svg";
export { ForwardRef as ReactComponent };